export let Spec = /*#__PURE__*/function (Spec) {
  Spec["UpgradeToNewSearch"] = "specs.siteSearch.UpgradeToNewSearch";
  return Spec;
}({});
//# sourceMappingURL=specs.js.map